import React from 'react';
import {Input} from 'antd';
import commonExtendsHOC from '../../commonExtendsHOC';

const {Password,Group,Search,TextArea}=Input;
export default commonExtendsHOC(Input);

const AisinoPassword =commonExtendsHOC(Password);
const AisinoGroup =commonExtendsHOC(Group);
const AisinoSearch =commonExtendsHOC(Search);
const AisinoTextArea =commonExtendsHOC(TextArea);
export {
    AisinoTextArea,
    AisinoSearch,
    AisinoGroup,
    AisinoPassword
}
